// eslint-disable-next-line import/no-unresolved
import { Notify } from 'notify/services/Notify';

const notify = Notify.getInstance();

const notifyAPIError = (error: unknown) => {
    return notify.addNotification((error as Error).message, {
        variant: 'error',
    });
};

export default notifyAPIError;
